import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { GuardComponent } from './core/security/guard/guard.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { EmitirRelatoriosComponent } from './modules/emitir-relatorio/emitir-relatorios.component';
import { ForbiddenComponent } from './core/components/forbidden/forbidden.component';
import { Role } from './config/authority.constants';
import { ExtratoProcessamentoEfdComponent } from './modules/extrato-processamento-efd/extrato-processamento-efd.component';
import { ValidarExtratoComponent } from './modules/validar-extrato/validar-extrato.component';

const routes: Routes = [
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: 'forbidden',
    pathMatch: 'full',
    component: ForbiddenComponent,
  },
  {
    path: 'obrigacoes-acessorias',
    pathMatch: 'prefix',
    component: EmitirRelatoriosComponent,
    data: { breadcrumb: 'Obrigações Acessórias' },
    canActivate: [GuardComponent],
  },
  {
    path: 'extrato-processamento-efd',
    pathMatch: 'prefix',
    component: ExtratoProcessamentoEfdComponent,
    data: {
      breadcrumb: 'Extrato Processamento EFD',
       permissions: {
         only: [Role.ROLE_EFD_CONSULTA_EXTRATO_EFD],
         redirectTo: '/forbidden'
       }
    },
    canActivate: [GuardComponent, ngxPermissionsGuard],
  },
  {
    path: 'validar-extrato',
    pathMatch: 'prefix',
    component: ValidarExtratoComponent,
    data: {
      breadcrumb: 'Validar Extrato',
      permissions: {
        only: [Role.ROLE_EFD_CONSULTA_EXTRATO_EFD],
        redirectTo: '/forbidden'
      }
    },
    canActivate: [GuardComponent, ngxPermissionsGuard],
  },
  { 
    path: '**', 
    redirectTo: '/obrigacoes-acessorias', 
    pathMatch: 'full' 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
